import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SearchViewComponentDef } from '@df/search/search-view.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsOutletBlockComponent } from '../../catalog/block/icms-outlet-block.component';
import { ProductListingComponent } from '../../ui/listing/product-listing.component';
import { ProductListing } from '../../ui/listing/product-listing.decorator';
import { SearchBannerComponent } from './search-banner.component';
import { SearchQuickLinksComponent } from './search-quick-links.component';
declare module '@df/search/search.interfaces' {
    namespace Search {
        interface ITerm {
            barePhrase: string;
        }
    }
}
@Component({
    selector: 'search-view',
    templateUrl: './search-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        SearchBannerComponent,
        ProductListingComponent,
        ICmsOutletBlockComponent,
        SearchQuickLinksComponent,
        TranslationModule,
        SizeClassDirective,
        CommonModule
    ]
})
export class SearchViewComponent extends SearchViewComponentDef {
    hasProductResults(): boolean {
        return !!this.result?.products?.length;
    }

    override listing!: ProductListing;
}
